import * as React from 'react';
import { connect } from 'react-redux';
import clsx from 'clsx';
import { CloseButton, Icons, LinkButton, Switcher } from 'components';
import { getOperation } from 'selectors';
import { IState } from 'services/root-reducer';
import { EOperationStatus, IOperation } from 'types';
import { actions as searchActions } from 'services/search/search-service';
import { actions as mapActions } from 'services/map/map-service';
import { SearchInput } from 'scenes/side-bar/search-input';
import { SearchType } from 'services/search/search-reducer';
import { CategorySelectorLite } from 'scenes/side-bar/category-selector-lite';
import { Key } from 'utils';
import { SearchResults } from 'scenes/side-bar/search-results';
import { WithTranslation, withTranslation } from 'react-i18next';
import i18n from 'i18next';
import './style.scss';

export interface IMobileUIAppHeaderProps extends WithTranslation {
    searchOperation: IOperation;
    searchState: IState['search'];
    pkkSettings: IState['app']['config']['publication']['settings']['customWidgets']['pkk_settings'];
    onCategorySelectorOpen: (category: string) => void;
    onMenuOpen?: () => void;
    onClose?: () => void;
    onToggleSearch: (v: boolean) => void;
    onToggleSearchRes: (v: boolean) => void
    currentCategory?: string;
    onSearchResultClick?: () => void
    searchOpen: boolean,
    searchResOpen: boolean
}
export interface IMobileUIAppHeaderState {
}

const mapStateToProps = (state: IState) => ({
    searchOperation: getOperation(state, 'SEARCH_OBJECTS_OMS'),
    searchState: state.search,
    pkkSettings: state.app.config.publication.settings.customWidgets.pkk_settings
});

class MobileUIAppHeaderComponent extends React.Component<IMobileUIAppHeaderProps, IMobileUIAppHeaderState> {
    constructor(props: IMobileUIAppHeaderProps) {
        super(props);
    }

    performSearch(search_type = this.props.searchState.search_type) {
        if (search_type === SearchType.Objects) {
            searchActions.performSearch({ type: 'objects', value: this.props.searchState.search_input_value });
        } else if (search_type === SearchType.Address) {
            searchActions.performSearch({ type: 'address', value: this.props.searchState.search_input_value });
        } else if (search_type === SearchType.Layers) {
            searchActions.performSearch({ type: 'layers', value: this.props.searchState.search_input_value });
        } else if (search_type === SearchType.PKK) {
            searchActions.performSearch({ type: 'pkk', value: this.props.searchState.search_input_value });
        }
    }

    renderSearch() {
        let {
            t, onSearchResultClick = () => {}, searchOpen, searchOperation, searchState, searchResOpen,
            onToggleSearchRes, pkkSettings
        } = this.props;
        const searchTypes = [
            { code: SearchType.Objects, label: t('Объекты') },
            { code: SearchType.Address, label: t('Адрес') },
            { code: SearchType.Layers, label: t('Слои') }
        ];
        if (pkkSettings.values.pkk_search_enabled && i18n.language === 'ru') {
            searchTypes.push({ code: SearchType.PKK, label: t('ПКК') });
        }
        return (
            <React.Fragment>
                <div className="search-controls">
                    <SearchInput
                        className='mobile-ui-search-input-wrapper'
                        inputValue={searchState.search_input_value}
                        searchOperation={searchOperation}
                        onInputClick={() => onToggleSearchRes(true)}
                        onCloseButtonClick={() => {
                            searchActions.clearState();
                            mapActions.highlightCadastreGeometry(null);
                            mapActions.placeYaAddressMarker(null);
                            this.props.onToggleSearch(false);
                        }}
                        onKeyDown={(event) => {
                            if (event.keyCode === Key.Enter) {
                                this.performSearch();
                            }
                        }}
                        onSearchInputChange={(value) => {
                            searchActions.setSearchInputValue(value);
                        }}
                    />

                    <Switcher
                        items={searchTypes}
                        className={clsx('tab-switcher-wrapper', 'mobile-ui-tab-switcher-wrapper', {
                            'disabled': searchOperation?.status === EOperationStatus.PENDING
                        })}
                        value={searchState.search_type}
                        onChange={(item) => {
                            searchActions.setSearchType(item.code as SearchType);
                            mapActions.placeYaAddressMarker(null);
                            if (searchState.search_input_value.length) {
                                this.performSearch(item.code as SearchType);
                            }
                        }}
                        onTabClick={(item) => onToggleSearchRes(true)}
                    />
                </div>

                {searchResOpen && (
                    <SearchResults
                        onSearchResultClick={() => {
                            onToggleSearchRes(false);
                            onSearchResultClick();
                        }}
                    />
                )}
            </React.Fragment>
        );
    }

    renderSearchNotActive() {
        let { t, onMenuOpen = () => {}, onClose = () => {}, currentCategory } = this.props;
        return (
            <div className="search-not-active-wrapper">
                <div className="search-top-part">
                    {currentCategory
                        ? <CloseButton onClick={onClose} />
                        : (
                            <LinkButton
                                icon={<Icons.IconMenu width={20} height={20} />}
                                className='menu'
                                onClick={onMenuOpen}
                            />
                        )}
                    {/* <div className="coa-wrapper">
                    <Icons.IconCoa />
                </div> */}
                    <div className="logo-text-wrapper">
                        {t('Ленинградская область')}
                    </div>

                    <LinkButton
                        icon={<Icons.IconMagnifyGlass width={20} height={20} />}
                        onClick={() => this.props.onToggleSearch(true)}
                        className='search'
                    />
                </div>

                <div className="search-bottom-part">
                    <CategorySelectorLite
                        disableHints
                        className='mobile-ui-category-selector-lite'
                        currentCategory={currentCategory || null}
                        onCategoryClick={this.props.onCategorySelectorOpen}
                    />
                </div>
            </div>
        );
    }

    render() {
        const { searchOpen, currentCategory } = this.props;
        return (
            <div
                className={clsx('mobile-ui-app-header', {
                    'search-active': searchOpen,
                    'from-category-panel': currentCategory
                })}
            >
                {
                    searchOpen
                        ? this.renderSearch()
                        : this.renderSearchNotActive()
                }
            </div>
        );
    }
}

export const MobileUIAppHeader = withTranslation()(connect(mapStateToProps)(MobileUIAppHeaderComponent));
